import React, { useMemo, useState } from "react";
import { buildPreview } from "../../lib/parseFiles";
import { ArrowClockwise, ArrowSquareOut, Monitor } from "@phosphor-icons/react";

export default function PreviewPanel({ files }) {
  const [key, setKey] = useState(0);
  const srcDoc = useMemo(() => buildPreview(files), [files]);

  const openNewTab = () => {
    const w = window.open();
    if (w) {
      w.document.write(srcDoc);
      w.document.close();
    }
  };

  return (
    <div className="h-full flex flex-col bg-forge-surface overflow-hidden">
      <div className="flex items-center justify-between h-9 px-3 border-b border-forge-border shrink-0">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-neutral-400">
          <Monitor size={14} className="text-forge-primary" /> Preview
        </div>
        <div className="flex items-center gap-1">
          <button
            data-testid="preview-refresh"
            onClick={() => setKey((k) => k + 1)}
            className="p-1.5 text-neutral-400 hover:text-white hover:bg-forge-hover rounded-sm transition-colors"
            title="Refresh"
          >
            <ArrowClockwise size={15} />
          </button>
          <button
            data-testid="preview-open-tab"
            onClick={openNewTab}
            disabled={!srcDoc}
            className="p-1.5 text-neutral-400 hover:text-white hover:bg-forge-hover rounded-sm transition-colors disabled:opacity-40"
            title="Open in new tab"
          >
            <ArrowSquareOut size={15} />
          </button>
        </div>
      </div>
      <div className="flex-1 bg-white overflow-hidden">
        {srcDoc ? (
          <iframe
            key={key}
            title="preview"
            srcDoc={srcDoc}
            sandbox="allow-scripts allow-modals allow-forms allow-popups allow-same-origin"
            className="w-full h-full border-0 bg-white"
            data-testid="preview-iframe"
          />
        ) : (
          <div className="h-full flex items-center justify-center bg-forge-bg text-neutral-600 text-sm font-mono px-8 text-center">
            {"// preview renders here once your app is generated"}
          </div>
        )}
      </div>
    </div>
  );
}
